module.exports = __webpack_public_path__ + "media/images/lb/026-69f855ea6c82fbd0fcbe8a7e7c872716.svg";